<template>
  <div class="content">
    <MenuTopo v-if="usuarioLogado" />
    <div id="panel">
      <div class="container">
        <ol v-if="breadcrumb.length" class="breadcrumb hidden-print">
          <li
            v-for="(menu, index) in breadcrumb"
            :key="menu"
            :class="{ active: index === breadcrumb.length - 1 }"
            >{{ menu }}</li
          >
        </ol>
        <main class="corpo">
          <transition>
            <RouterView />
          </transition>
        </main>
      </div>
      <footer class="rodape hidden-print text-center">
        <p>
          &copy; 2017 - {{ ano }} <strong>CARDEA</strong> &#8226;
          <span class="text-info">
            {{ versao }} ({{ commitHash }}) / {{ versaoBackend }}
          </span></p
        >
      </footer>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import MenuTopo from '@/componentes/navegacao/MenuTopo'
import appStore from '@/stores'

export default {
  name: 'App',
  components: {
    MenuTopo,
  },
  computed: {
    usuarioLogado() {
      return appStore.autenticado
    },
    versaoBackend() {
      return appStore.versaoBackend || '-'
    },
    breadcrumb() {
      return Array.isArray(appStore.breadcrumb) ? appStore.breadcrumb : []
    },
    versao() {
      // eslint-disable-next-line no-undef
      return VERSION || process.env.VUE_APP_VERSION || '-'
    },
    commitHash() {
      // eslint-disable-next-line no-undef
      return COMMITHASH || process.env.VUE_APP_COMMIT_HASH || '-'
    },
    ano() {
      return moment().format('YYYY')
    },
  },
}
</script>

<style lang="less">
@import './assets/less/style.less';

.corpo {
  min-height: 100vh;
  margin-bottom: 40px;
}

.spinner {
  position: fixed;
  right: 10px;
  left: auto;
  z-index: 999;
  text-align: right;
}

.rodape {
  position: sticky;
  bottom: 0;
  z-index: 3;
  width: 100%;
  height: 46px;
  padding: 15px;
  background-color: #ecf0f1;
}
</style>
